<template>
  <div class="documents-page-wrapper">
    <static-pages-header @mobileMenuToggle="mobileMenuToggle"/>
    <div class="documents-container" :class="{'heading-container-mobile-menu-open': isMobileMenuOpen}">
      <nav class="documents-nav">
        <router-link :to="{ name: 'documentsActive' }" class="documents-nav-item">
          {{ $t('message.documentsPage.tabs.active') }}
        </router-link>
        
        <router-link :to="{ name: 'documentsPending' }" class="documents-nav-item">
          {{ $t('message.documentsPage.tabs.pending') }}
        </router-link>

        <router-link :to="{ name: 'documentsArchive' }" class="documents-nav-item">
          {{ $t('message.documentsPage.tabs.archive') }}
        </router-link>
      </nav>
    </div>

    <router-view />
  </div>
</template>

<script>
import StaticPagesHeader from '../../components/common/StaticPagesHeader.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'Documents',
  components: {
    StaticPagesHeader
  },
  data() {
    return {
      isMobileMenuOpen: false,
    }
  },
  methods: {
    mobileMenuToggle(value) {
      this.isMobileMenuOpen = value;
    },
    signUp() {
      this.$router.push({ name: 'msi' });
    },
  },
  computed: {
    ...mapGetters(['profile']),
    isAuthorized() {
      return this.profile?.role;
    },
  }
}
</script>

<style lang="scss" scoped>
.documents-page-wrapper {
  @include base-page-wrapper;
  @include static-heading-container;

  min-height: auto;
}

.documents-container {
    @include base-page-container;

    padding: 20px 0 30px 0;
    box-sizing: border-box;
    justify-content: flex-start;
    flex-direction: column;
  }

  .documents-nav {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    width: fit-content;
  }

  .documents-nav-item {
    padding: 10px;
    font-size: 1.25rem;
    color: #7a7a7a;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    transition: all .2s ease;
    font-weight: 600;

    &:hover {
      border-bottom: 2px solid #33a568;
      color: #01273b;
    }
  }

  .documents-nav-item.router-link-active,
  .documents-nav-item.router-link-exact-active {
    border-bottom: 2px solid #33a568;
    color: #01273b;
  }

  @media screen and (max-width: 768px) {
    .documents-nav {
      gap: 10px;
      flex-wrap: wrap;
    }

    .documents-nav-item {
      padding: 7px 8px;
      font-size: 0.95rem;
    }
  }

  @media screen and (max-width: 480px) {
    .documents-nav-item {
      padding: 6px 7px;
      font-size: 0.85rem;
    }
  }
</style>